import React from "react";
import { useNavigate } from "react-router-dom";

const Navigate = ({ children, path, state }) => {
    const navigate = useNavigate();

    const handleNavigation = () => {
        if (path) {
            navigate(path, { state });
        }
    };

    return (
        <div onClick={handleNavigation} style={{ cursor: 'pointer' }}>
            {children}
        </div>
    );
};

export default Navigate;